import React from 'react';
import { useNavigate } from 'react-router-dom';
import {useQuery} from "react-query";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from 'react-i18next';
import Loadingcomponent from '../../loader/loadingcomponent';
import { redirecturl } from '../../../services/common/redirect';
import RoamingHomeBottomBanners from '../../../ShimmerEffect/RoamingHomeBottomBanners';
import { getImgSrc } from '../../../services/common/CommonUtils';

function BottomBanners({pmsitem}) {
    const {data: {data}={}, isLoading, isFetching, isError, error, isLoadingError} = useQuery(['', pmsitem?.method, JSON.parse(pmsitem?.sourceid)]);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleClick  = (url) =>{
      redirecturl(url, navigate, null, null, null, null, true)
    }
  return (
    isLoading || isFetching ? <RoamingHomeBottomBanners/> : 
    data?.response &&
    <div className="promo-detail-pg dls-sprint13-comp pse_sm">
      <h5 className="mt-4">{pmsitem?.elementmeta?.title}</h5>
      <div>
        <Swiper
            className="swiper-wrapper pt-4"
            slidesPerView={2} 
            pagination={{
              clickable: true
            }}
            spaceBetween={12}
        >
          {data?.response?.[0]?.banners.map((item) => (
            <SwiperSlide>
              <img onClick={()=> handleClick(item?.url)} 
              // src={item?.path+"?t="+item?.updateddate || ''}
              src={getImgSrc(`${item?.path+"?t="+item?.updateddate}`, true)}
              class="w-100" alt="" title=""/>
            </SwiperSlide> 
          ))}
          </Swiper>
      </div>
    </div>
  )
}

export default BottomBanners
